import { NavLink, Outlet } from "react-router";
import { AdBanner } from "./AdBanner.js";

const tabs = [
  { to: "/", label: "ホーム" },
  { to: "/search", label: "検索" },
  { to: "/cross", label: "クロス" },
  { to: "/yutai", label: "優待" },
  { to: "/my", label: "マイ" },
];

export function AppLayout() {
  return (
    <div className="app">
      <main className="app-main">
        <Outlet />
        <AdBanner />
      </main>
      <nav className="tabbar" aria-label="メインナビゲーション">
        {tabs.map((t) => (
          <NavLink key={t.to} to={t.to} end={t.to === "/"} className={({ isActive }) => (isActive ? "tab active" : "tab")}>
            {t.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
